<template>
  <div class="timespan-selector">
    <el-date-picker size="mini" type="daterange" range-separator="-" :unlink-panels="true" v-model="currentValue"></el-date-picker>
    <el-radio-group v-model="customerBarPeriodType" size="mini">
      <el-radio-button :label="1">当月</el-radio-button>
      <el-radio-button :label="2">累计</el-radio-button>
    </el-radio-group>
  </div>
</template>
<script>
export default {
  name: 'TimeSpanSelector',
  model: {
    prop: 'timeSpan',
    event: 'change'
  },
  props: {
    timeSpan: {
      type: Array,
      default () {
        return null
      }
    },
    rangeType: {
      type: String,
      default () {
        return 'daterange'
      }
    }
  },
  beforeMount () {
    this.currentValue = this.timeSpan
  },
  data () {
    const now = new Date()
    const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    const startTime = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      currentValue: [startTime, endTime],
      customerBarPeriodType: 1
    }
  },
  watch: {
    customerBarPeriodType (val) {
      if (val === 1) {
        const now = new Date()
        const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
        const startTime = new Date(now.getFullYear(), now.getMonth(), 1)
        if (this.currentValue === null || (this.currentValue[0].getTime() !== startTime.getTime() || this.currentValue[1].getTime() !== endTime.getTime())) {
          this.$nextTick(() => {
            this.currentValue = [startTime, endTime]
          })
        }
      } else if (val === 2) {
        if (this.currentValue !== null) {
          this.$nextTick(() => {
            this.currentValue = null
          })
        }
      }
    },
    currentValue (newVal, oldVal) {
      if (newVal === null) {
        if (this.customerBarPeriodType !== 2) {
          this.$nextTick(() => {
            this.customerBarPeriodType = 2
          })
        }
      } else if (oldVal === null || (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1])) {
        const now = new Date()
        const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime()
        const startTime = new Date(now.getFullYear(), now.getMonth(), 1).getTime()
        let newValSt = (newVal[0] && newVal[0].getTime && newVal[0].getTime()) || undefined
        let newValEt = (newVal[1] && newVal[1].getTime && newVal[1].getTime()) || undefined
        if (newValSt === startTime && newValEt === endTime) {
          if (this.customerBarPeriodType !== 1) {
            this.$nextTick(() => {
              this.customerBarPeriodType = 1
            })
          }
        } else {
          if (this.customerBarPeriodType !== undefined) {
            this.$nextTick(() => {
              this.customerBarPeriodType = undefined
            })
          }
        }
      }
      this.$emit('change', newVal)
    }
  }
}
</script>
